import {Component} from 'preact';

/*
export default class Picture extends Component {
  constructor(props) {
    super(props);
    // this.source = (this.props.source) ? this.props.source : null;
    this.attributes = (this.props.attributes) ? this.props.attributes : {};
    this.author = (this.props.author) ? this.props.author : null;
    this.className = (this.props.className) ? this.props.className : {};
  }

  componentWillReceiveProps(nextProps) {
    this.attributes = (nextProps.attributes) ? nextProps.attributes : {};
    this.author = (nextProps.author) ? nextProps.author : null;
    this.className = (nextProps.className) ? nextProps.className : {};
  }

  componentWillUnmount(attr1) {
    const image = document.querySelector('.content__photo-wraper img');
    if (image && !image.complete) {
      image.classList.add('content__photo-loading');
    }
    this.attributes = null;
    this.author = null;
    this.className = null;
  }

  render() {
    const picture = (this.attributes.src) ? <div className={(this.className.contentWraper) ? this.className.contentWraper : "content__photo-wraper"}><img onLoad={(evt) => {evt.target.classList.remove('content__photo-loading')}} {...this.attributes}/></div> : null;
    const pictureAuthor = (this.author) ? <div className={(this.className.author) ? this.className.author : "content__photo-legend"}>{this.author}</div> : null;
    return (picture) ? <div className={(this.className.content) ? this.className.content : "content__photo"}>
                      {picture}
                      {pictureAuthor}
                    </div> : null;
  }
}
*/

const Picture = (props) => {
  const attributes = (props.attributes) ? props.attributes : {};
  const author = (props.author) ? props.author : null;
  const className = (props.className) ? props.className : {};

  const picture = (attributes.src) ? <div className={(className.contentWraper) ? className.contentWraper : "content__photo-wraper"}><img onLoad={(evt) => {evt.target.classList.remove('content__photo-loading')}} className={'content__photo-loading'} {...attributes}/></div> : null;
  const pictureAuthor = (author) ? <div className={(className.author) ? className.author : "content__photo-legend"}>{author}</div> : null;
  return (picture) ? <div className={(className.content) ? className.content : "content__photo"}>
                    {picture}
                    {pictureAuthor}
                  </div> : null;
}

export default Picture;



// WEBPACK FOOTER //
// ./components/picture.js